<template>
  <div class="widget widget-stats mb-7px bg-teal-600">
    <div class="stats-icon stats-icon-lg">
      <i class="fa fa-signature fa-fw"></i>
    </div>
    <router-link :to="'/tasks/' + taskId + '/edit'">
      <div class="stats-content">
        <div class="stats-title text-truncate text-white">
          {{ topText }}
        </div>
        <div class="stats-number text-truncate text-white">
          <span :title="title">{{ title }}</span>
          <br />
          <span class="fs-6" :title="subTitle">{{ subTitle }}</span>
        </div>
        <h6 class="text-white" v-if="taskName">
          {{ taskId }} | {{ taskName }}
        </h6>
        <div class="stats-desc text-white">
          {{ date }}
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    taskId: Number,
    taskName: String,
    topText: String,
    title: String,
    subTitle: String,
    date: String,
    viewLink: String,
    signable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
};
</script>
<style>
a:hover {
  text-decoration: none;
}
</style>
